export const USER_CHARGE_LIST = 'user/rechargeList';